export default __webpack_public_path__ + "static/hdmi_xr_adapter-14ead9b185c3367c0590aee69be49287.png";